"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const WishListReducer_1 = require("../../wishList/reducers/WishListReducer");
const WishListSaga_1 = tslib_1.__importDefault(require("../../wishList/sagas/WishListSaga"));
const loadWishListModule = () => ({
    id: 'WishList',
    reducerMap: {
        wishList: WishListReducer_1.wishListReducer,
    },
    sagas: [WishListSaga_1.default],
});
exports.default = loadWishListModule;
